export const apiUrl = `${process.env.NEXT_PUBLIC_API_URL}/api`;

export const baseUrl = process.env.NEXT_PUBLIC_API_URL;

export const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://dwellfinders.com";

export const googleAdsPid = process.env.NEXT_PUBLIC_GOOGLE_ADS_PID ?? "";

export const googleHorizontalAds = process.env.NEXT_PUBLIC_GOOGLE_HORIZONTAL_ADS ?? "";

export const googleVerticalAds = process.env.NEXT_PUBLIC_GOOGLE_VERTICAL_ADS ?? "";

export const googleSquareAds = process.env.NEXT_PUBLIC_GOOGLE_SQUARE_ADS ?? "";

export const paypalClientId = `${process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID}`;

export const paypalPlanId = `${process.env.NEXT_PUBLIC_PAYPAL_PLAN_ID}`;

// OAuth
export const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "";
export const appleClientId = process.env.NEXT_PUBLIC_APPLE_CLIENT_ID ?? "";
export const appleRedirectUri = process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI ?? "";
